import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
/* eslint-disable react/prop-types */

const countryOptions = [
  { value: "Value 1", label: "Value 1" },
  { value: "Value 2", label: "Value 2" },
];

function Fields7({ formData }) {
  const { formField7, values, errors, touched } = formData;
  const { endow, departmentLevel, subordinateToTheDepartment, city, district, commune } =
    formField7;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={endow.type}
            label={endow.label}
            name={endow.name}
            value={values.endow}
            placeholder={endow.placeholder}
            error={errors.endow && touched.endow}
            success={values.endow.length > 0 && !errors.endow}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={departmentLevel.type}
            label={departmentLevel.label}
            name={departmentLevel.name}
            value={values.departmentLevel}
            placeholder={departmentLevel.placeholder}
            error={errors.departmentLevel && touched.departmentLevel}
            success={values.departmentLevel.length > 0 && !errors.departmentLevel}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={subordinateToTheDepartment.type}
            label={subordinateToTheDepartment.label}
            name={subordinateToTheDepartment.name}
            value={values.subordinateToTheDepartment}
            placeholder={subordinateToTheDepartment.placeholder}
            error={errors.subordinateToTheDepartment && touched.subordinateToTheDepartment}
            success={
              values.subordinateToTheDepartment.length > 0 && !errors.subordinateToTheDepartment
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
        <SoftBox ml={0.5} lineHeight={0} display="inline-block">
          <SoftTypography component="label" variant="caption" fontWeight="bold">
          [09] Địa phuơng nơi có đơn vị phụ thuộc/ địa điểm kinh doanh có thu nhập được hưởng ưu đãi khác tỉnh nơi đóng trụ sở chính:
          </SoftTypography>
        </SoftBox>
        </Grid>

        <Grid item xs={4} style={{ paddingTop: 0 }} >
          <SelectField
            options={countryOptions}
            type={city.type}
            label={city.label}
            name={city.name}
            value={values.city}
            placeholder={city.placeholder}
            error={errors.city && touched.city}
            success={values.city.length > 0 && !errors.city}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={district.type}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={commune.type}
            label={commune.label}
            name={commune.name}
            value={values.commune}
            placeholder={commune.placeholder}
            error={errors.commune && touched.commune}
            success={values.commune.length > 0 && !errors.commune}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields7);
